<template>
    <div
        class="dropdown border-default bg-primary-white end-date-dropdown"
        ref="dropdownWrap"
        :class="{
            '': !endDate,
            '': endDate
        }"
        id="dropdown-container"
    >
        <button
            id="end-date"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="align-items-center w-100 border-0 d-flex h-100 outline-none text-nowrap bg-primary-white line-height-0 position-absolute top-0 left-0 bg-none"
            :class="{
                'dropdown-toggle': !endDate,
                '': endDate
            }"
            ref="dropdown"
        >
            <CalendarIcon></CalendarIcon>

            <span class="subcaption text-primary-black content me-2" :class="{ 'subcaption-strong': endDate }">
                {{ endDate ? displayValue : store.contents.endDate }}
            </span>
            <span class="justify-content-end flex-grow-1 arrow-down">
                <ArrowDown></ArrowDown>
            </span>

            <span class="justify-content-end flex-grow-1 arrow-up">
                <ArrowUp></ArrowUp>
            </span>
        </button>
        <div
            class="dropdown-menu dropdown-menu-right dropdown-menu-lg-left dropdown-menu calendar-dropdown-menu shadow-4 pt-0 px-2 pb-2 min-w-100"
            @click.stop
        >
            <Datepicker
                :value="endDate"
                :get-default-date="getDefaultDate"
                :get-available-dates="getAvailableDates"
                :month="startDateMonth"
                :show-other-months="true"
                :contents="store.contents.datepicker"
                :key="state.key"
                :store="store"
                :show-next-season-button="false"
                @change="change"

            ></Datepicker>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import CalendarIcon from '@se/components/svg/se/calendar/index.vue'
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import { onClickOutside } from '@vueuse/core'

import Datepicker from '@se/components/datepicker.vue'

export default {
    name: 'EndDate',
    components: {
        Datepicker,
        CalendarIcon,
        ArrowUp,
        ArrowDown
    },
    props: {
        store: Object,
        events: Object
    },
    data: function () {
        return {
            state: {
                key: 0
            }
        }
    },
    computed: {
        displayValue() {
            if (this.endDate) {
                return moment(this.endDate).format('DD/MM/YYYY')
            }
        },
        startDateMonth: function () {
            var startDate = this.store.data.selected.startDate
            if (!startDate) {
                return null
            }
            var monthStr = moment(startDate).format('YYYY-MM')
            return monthStr
        },
        endDate: function () {
            return this.store.data.selected.endDate
        }
    },
    methods: {
        getDefaultDate: function (dates) {
            var startDate = this.store.libs.se.getFieldValue('beginDate')

            if (!startDate) {
                return null
            }

            var d = startDate.split('-')
            var d7 = new Date(d[0], parseInt(d[1]) - 1, parseInt(d[2]) + 7) // seven days offset
            var dateStr = moment(d7).format('YYYY-MM-DD')

            var offsetDate = dates.find(function (date) {
                return date === dateStr
            })
            if (offsetDate) {
                return new Date(offsetDate)
            }
            return new Date(dates[0])
        },
        getAvailableDates: function (monthStr, nextMonth) {
            return this.store.libs.se.requestEndDates(monthStr, nextMonth)
        },
        change: function (date) {
            var endDate = moment(date).format('YYYY-MM-DD')
            this.store.libs.se.setFieldValue('endDate', endDate)
            $(this.$refs.dropdown).dropdown('hide')
            this.$emit('select')
        },
        clear: function () {
            this.store.libs.se.setFieldValue('endDate', undefined)
            this.showDropdown()
        },
        showDropdown: function () {
            $(this.$refs.dropdown).dropdown('show')
        }
    },
    beforeDestroy: function () {
        $(this.$refs.dropdown).dropdown('dispose')
    },
    mounted: function () {
        var self = this
        this.events.on('show', function () {
            self.showDropdown()
        })
        this.events.on('hide', function () {
            $(self.$refs.dropdown).dropdown('hide')
        })
        var dropdownWrap = $(this.$refs.dropdownWrap)
        dropdownWrap.on('show.bs.dropdown', function () {
            try {
                self.$emit('show')
                self.state.key++
            } catch (e) {}
        })
        dropdownWrap.on('shown.bs.dropdown', function () {
            self.$emit('shown')
            setTimeout(function () {
                // $(self.$refs.dropdownWrap).addClass('show')
            }, 1000)
        })
        dropdownWrap.on('hide.bs.dropdown', function () {
            self.$emit('hide')
        })
        dropdownWrap.on('hidden.bs.dropdown', function () {
            self.$emit('hidden')
        })

        onClickOutside(this.$refs.dropdownWrap, () => {
            $(this.$refs.dropdown).dropdown('hide')
        })
    }
}
</script>

<style scoped>
.arrow-up {
    display: flex;
}

.arrow-down {
    display: none;
}

.end-date-dropdown.show .arrow-down {
    display: flex;
}

.end-date-dropdown.show .arrow-up {
    display: none;
}
</style>
